/**
 * Pure authorization predicate used by ProtectedRoute. When no allowedRoles
 * are configured the route is open to any authenticated user; otherwise the
 * user's role must be present in the allow-list.
 */
export function isRoleAllowed(
  allowedRoles: string[] | undefined,
  role: string | undefined
): boolean {
  if (!allowedRoles) return true;
  return role !== undefined && allowedRoles.includes(role);
}
